// Zentrale Konstanten für die native Autoeinfachlos-App (Prod):
// Deep-Link-Scheme und die offiziellen Store-Einträge.
export const APP_SCHEME = "autoeinfachlos";

// Google Play: Package "at.autoeinfachlos.app"
export const ANDROID_PACKAGE_ID = "at.autoeinfachlos.app";
export const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE_ID}&hl=de_AT`;

// Apple App Store: "Autoeinfachlos" (Web3 DevOps GmbH)
export const APP_STORE_URL =
  "https://apps.apple.com/at/app/autoeinfachlos/id6787159475";

// Passender Store-Eintrag für das aktuelle Gerät. iPadOS meldet sich teils als
// "Macintosh", daher zusätzlich die Touch-Punkte prüfen. Ist die Plattform
// unklar (Desktop), gibt es keinen sinnvollen Einzel-Store -> "".
export const getStoreUrl = () => {
  if (typeof navigator === "undefined") return "";
  const ua = navigator.userAgent || "";
  const isIOS =
    /iPhone|iPad|iPod/i.test(ua) ||
    (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1);
  if (isIOS) return APP_STORE_URL;
  if (/Android/i.test(ua)) return PLAY_STORE_URL;
  return "";
};

// intent://-URL für Chromium-Browser auf Android (Chrome, Samsung Internet, …):
// öffnet die App, wenn installiert, sonst leitet der Browser selbst über
// browser_fallback_url in den Play Store – ohne fehleranfällige Timer-Heuristik.
export const buildAndroidIntentUrl = (path, query) =>
  `intent://${path}?${query}#Intent;scheme=${APP_SCHEME};package=${ANDROID_PACKAGE_ID};S.browser_fallback_url=${encodeURIComponent(
    PLAY_STORE_URL,
  )};end`;
